import {DAY_MS, iso, makeShareToken, EUROPE_COUNTRIES, MOCK_ICCID, MOCK_DOMAIN_ID, MOCK_ACTIVATION_CODE, MOCK_RESELLER_INFORMATION} from "./shared";

// "Expired" demo: the package's validity window ended 10 days ago - the
// expiry bar should read 100%/full and red, and the pill/status card should
// switch to an "Expired" state offering a "Browse packages" card instead of
// the normal usage details.
function dates() {
    return {
        activatedAt: iso(-40 * DAY_MS),
        expiresAt: iso(-10 * DAY_MS),
        salesDate: iso(-41 * DAY_MS)
    };
}

export function getMockCustomerProfile() {
    const {activatedAt, expiresAt, salesDate} = dates();

    return {
        totalAvailableBalance: {sizeValue: 2.1, sizeUnit: "GB"},
        balances: [
            {
                price: {priceValue: 14.99, currencyCode: "USD"},
                salesDate,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                includedCountries: EUROPE_COUNTRIES,
                balance: {
                    name: "Europe Data Pack",
                    activatedAt,
                    expiresAt,
                    activationMode: "NOW",
                    size: {sizeValue: 10, sizeUnit: "GB"},
                    availableBalance: {sizeValue: 2.1, sizeUnit: "GB"},
                    validitySize: 30, validityUnit: "days",
                    countrySet: "eur",
                    extendedDataPolicy: null
                }
            }
        ],
        relatedEsims: [
            {
                uid: "esim-uid-002",
                active: true,
                state: "Installed",
                iccid: MOCK_ICCID,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                activatedAt,
                lastSeen: iso(-10 * DAY_MS),
                installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
                appleUniversalLink: "https://example.com/esim/apple-install",
                androidUniversalLink: "https://example.com/esim/android-install",
                activationCode: MOCK_ACTIVATION_CODE,
                imsi: ""
            }
        ],
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}

export function getMockEsimData() {
    const {activatedAt, expiresAt} = dates();

    return {
        esimProfile: {
            uid: "esim-uid-002",
            active: true,
            state: "Installed",
            iccid: MOCK_ICCID,
            customerProfileDomainId: MOCK_DOMAIN_ID,
            activatedAt,
            lastSeen: iso(-10 * DAY_MS),
            installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
            appleUniversalLink: "https://example.com/esim/apple-install",
            androidUniversalLink: "https://example.com/esim/android-install",
            activationCode: MOCK_ACTIVATION_CODE,
            imsi: ""
        },
        balances: [
            {
                name: "Europe Data Pack",
                activatedAt,
                expiresAt,
                activationMode: "NOW",
                size: {sizeValue: 10, sizeUnit: "GB"},
                availableBalance: {sizeValue: 2.1, sizeUnit: "GB"},
                validitySize: 30, validityUnit: "days",
                countrySet: "eur",
                extendedDataPolicy: null
            }
        ],
        totalAvailableBalance: {sizeValue: 2.1, sizeUnit: "GB"},
        customerProfileUrl: "https://example.com/customer/profile?token=mock-customer-token",
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}
